var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1321316605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.69555 14.9351C9.76379 14.7676 9.84812 14.6072 9.94735 14.4561L9.9105 16.6669H8.44885C9.022 16.2213 9.45478 15.62 9.69555 14.9351Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.63125 13.6009C9.08738 13.8098 9.52856 14.0498 9.95165 14.3194C9.76127 14.2764 9.16555 14.1168 8.94446 14.0308C6.52477 13.0359 3.70588 13.6132 2.18896 14.0308L4.06822 10.3828C5.2923 11.8245 6.86236 12.9317 8.63125 13.6009Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.94612 14.6688C9.27618 14.5521 9.61242 14.4537 9.95331 14.374C9.79212 14.485 9.61909 14.5777 9.43742 14.6504C8.4478 15.0132 7.62313 15.7223 7.11599 16.6463H0.833374L1.88969 14.589C3.28992 15.0619 6.12109 15.8664 8.94612 14.6688Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.53023 12.6986C9.7057 13.1585 9.84733 13.6306 9.95398 14.1111V14.2585C9.80045 13.9944 9.38283 13.282 9.26 12.9811C8.48187 10.9281 7.13569 9.13885 5.37866 7.82235L7.69395 3.33301H9.21701C8.51689 5.88167 7.87206 9.3147 9.53023 12.6986Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.584 16.6658H10.1101L10.0732 14.4365C10.1777 14.5931 10.2662 14.7597 10.3373 14.934C10.5823 15.6167 11.0143 16.2168 11.584 16.6658Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.782 12.9811C10.5593 13.4257 10.3133 13.8583 10.045 14.2769V14.0988C10.1425 13.6199 10.2843 13.1511 10.4688 12.6986C12.1822 9.62791 11.5005 6.0045 10.7759 3.33301H12.2989L14.6265 7.82849C12.8857 9.15004 11.5531 10.936 10.782 12.9811Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.403 13.602C13.1759 12.9428 14.7508 11.8414 15.9783 10.4023L17.8637 14.0442C16.3284 13.6266 13.5156 13.0616 11.1082 14.0442C10.881 14.1363 10.2607 14.296 10.0887 14.339C10.51 14.0644 10.949 13.8182 11.403 13.602Z",
    fill: "#4FA778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.2177 16.6661H12.9228C12.414 15.7435 11.5899 15.035 10.6014 14.6702C10.4167 14.5931 10.2399 14.4985 10.0732 14.3877C10.4184 14.4691 10.7587 14.5696 11.0927 14.6886C13.9177 15.9169 16.7551 15.0817 18.1553 14.6272L19.2177 16.6661Z",
    fill: "#4FA778"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.293b3ad88763c90484c9c367c2a0e6eb.svg";
export { ForwardRef as ReactComponent };